import React from 'react';
export function Footer() {
  return <footer className="bg-brand-forest text-brand-sage py-12 border-t border-white/10" data-id="element-68">
      <div className="max-w-6xl mx-auto px-6 text-center" data-id="element-69">
        <p className="text-sm mb-6 max-w-3xl mx-auto leading-relaxed opacity-80" data-id="element-70">
          Descargo de responsabilidad: Este producto no sustituye el consejo
          médico profesional. Consulte a su médico antes de comenzar cualquier
          programa de nutrición o ejercicio. Los resultados pueden variar de
          persona a persona dependiendo del compromiso y las condiciones
          individuales.
        </p>
        <div className="flex justify-center gap-6 text-sm opacity-80" data-id="element-71">
          <a href="#" className="hover:text-white transition-colors" data-id="element-72">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-73">
            Política de Privacidad
          </a>
        </div>
        <p className="mt-8 text-xs opacity-60" data-id="element-74">
          © {new Date().getFullYear()} 24 Pasos a Tu Peso Ideal. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}